import { ShopOutlined } from '@ant-design/icons';
import { Button, Col } from 'antd';
import FormFields from '../../../themes/admin/Fields/FormFields';
import { type FormItemProps } from '../FormItem';
import { type SelectFieldProps } from '../SelectField';
import { type TranslationDrawerProps } from '../TranslatedInputField/TranslationDrawer';
import { useTranslationMultipleEntryDrawer } from '../TranslatedInputFieldArray/TranslationDrawer';
import { useDisclaimerMultipleEntryDrawer } from './DisclaimerMultipleEntryDrawer';

export type DisclaimerKind = 'priceDisclaimer' | 'financingDisclaimer' | 'insuranceDisclaimer';

export type DisclaimersDrawerFieldProps = Pick<
    SelectFieldProps,
    'options' | 'name' | 'disabled' | 'label' | 'itemProps'
> &
    Pick<TranslationDrawerProps, 'languages'> & {
        isEdit?: boolean;
        isMultipleEntry?: boolean;
        disclaimerKind: DisclaimerKind;
        tooltip?: FormItemProps['tooltip'];
    };

const DisclaimersDrawerField = ({
    name,
    disabled,
    languages,
    options,
    isEdit,
    isMultipleEntry,
    disclaimerKind,
    ...props
}: DisclaimersDrawerFieldProps) => {
    const multiplEntryDrawer = useDisclaimerMultipleEntryDrawer(disabled);
    const translatedMultipleEntryDrawer = useTranslationMultipleEntryDrawer(disabled);
    // hide button completely when disable
    const button = disabled ? null : (
        <Button
            icon={<ShopOutlined style={{ color: 'var(--ant-primary-color)' }} />}
            onClick={multiplEntryDrawer.open}
            size="small"
            type="text"
        />
    );

    return (
        <>
            <Col onClick={multiplEntryDrawer.open}>
                <FormFields.InputField
                    name={`${name}[0].${disclaimerKind}.defaultValue`}
                    {...props}
                    addonAfter={button}
                    onClick={multiplEntryDrawer.open}
                    style={{ width: '100%' }}
                    disabled
                />
            </Col>
            {multiplEntryDrawer.render({ name, title: props.label, options, disclaimerKind })}
            {translatedMultipleEntryDrawer.render({ name: name, title: props.label, languages })}
        </>
    );
};

export default DisclaimersDrawerField;
